import Link from '@/lib/siteLink';
import { VIKAS_SOCIALS } from './vikasSocials';
import PlatformIcon from '@/components/PlatformIcon';

export default function VikasFooter() {
  return (
    <footer className="border-t border-gray-100 py-12 bg-white" data-testid="vikas-footer">
      <div className="max-w-3xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row items-start justify-between gap-8">
          <div>
            <p className="font-serif text-lg font-bold text-black mb-2">Vikasifications</p>
            <p className="text-sm text-black max-w-xs">Essays, books, and experiments for founders building without a Plan B.</p>
            <a href="mailto:hi@vikasifications.com" className="text-sm text-black hover:underline mt-3 inline-block">hi@vikasifications.com</a>
          </div>
          <div className="flex gap-8">
            <div>
              <p className="text-[10px] font-bold text-black uppercase tracking-widest mb-3">Navigate</p>
              <ul className="space-y-2">
                <li><Link to="/vikas" className="text-sm text-black hover:text-black transition-colors">Home</Link></li>
                <li><Link to="/vikas/blog" className="text-sm text-black hover:text-black transition-colors">Writing</Link></li>
                <li><Link to="/vikas/work-with-me" className="text-sm text-black hover:text-black transition-colors">For founders</Link></li>
                <li><Link to="/vikas/book" className="text-sm text-black hover:text-black transition-colors">Book</Link></li>
                <li><Link to="/vikas/speaking" className="text-sm text-black hover:text-black transition-colors">Speaking</Link></li>
                <li><Link to="/vikas/contact" className="text-sm text-black hover:text-black transition-colors">Contact</Link></li>
              </ul>
            </div>
            <div>
              <p className="text-[10px] font-bold text-black uppercase tracking-widest mb-3">Connect</p>
              <ul className="space-y-2">
                <li className="flex gap-3.5 pb-1">
                  {VIKAS_SOCIALS.map((s) => (
                    <a key={s.href} href={s.href} target="_blank" rel="me noopener noreferrer" aria-label={`Vikas Goel on ${s.label}`} title={s.label} className="text-black/70 hover:text-black transition-colors">
                      <PlatformIcon name={s.icon} className="w-[18px] h-[18px]" />
                    </a>
                  ))}
                </li>
                <li><a href="https://www.dgtg.in" target="_blank" rel="noopener noreferrer" className="text-sm text-black hover:text-black transition-colors">DGTG</a></li>
                <li><a href="https://www.battlexo.com" target="_blank" rel="noopener noreferrer" className="text-sm text-black hover:text-black transition-colors">XO (BattleXO)</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-gray-50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-black">&copy; 2026 Vikas Goel. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/vikas/privacy" className="text-[11px] text-black hover:text-black transition-colors">Privacy Policy</Link>
            <Link to="/vikas/terms" className="text-[11px] text-black hover:text-black transition-colors">Terms of Use</Link>
            <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer" className="text-[11px] text-black hover:text-black transition-colors" data-testid="vikas-footer-sitemap">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
